/* eslint-disable max-lines-per-function */
import {
  Button,
  Label,
  RadioGroup,
  RadioGroupItem,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@e2n/ui';
import { Anzeige } from '@/domain/controlling/entities/tagebuchAnzeige';
import {
  AbsatzProduktivitaetForm,
  UmsatzAbsatzProduktivitaetForm,
  UmsatzProduktivitaetForm,
} from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms';
import { useEinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenFormContext';
import { useTranslation } from 'react-i18next';

export function EinstellungenSheetContent() {
  const { t } = useTranslation();
  const form = useEinstellungenFormContext();

  return (
    <SheetContent className="w-92 overflow-y-auto">
      <SheetHeader>
        <SheetTitle>
          {t('domain.controlling.umsatzplanung.einstellungen.title')}
        </SheetTitle>
        <SheetDescription>
          {t('domain.controlling.umsatzplanung.einstellungen.subtitle')}
        </SheetDescription>
      </SheetHeader>
      <div className="flex flex-col gap-4 py-6">
        <form.Subscribe
          selector={(state) => ({
            umsatzplanungAnzeige: state.values.umsatzplanungAnzeige,
          })}>
          {({ umsatzplanungAnzeige }) => (
            <form.AppField
              name="umsatzplanungAnzeige"
              listeners={{
                onChange: ({ value }) => {
                  if (value === 'UMSATZ_PRODUKTIVITAET') {
                    form.resetField('zielProduktivitaetAbsatz');
                  }
                  if (value === 'ABSATZ_PRODUKTIVITAET') {
                    form.resetField('zielProduktivitaetUmsatz');
                  }
                },
              }}>
              {(field) => (
                <RadioGroup
                  value={field.state.value}
                  onValueChange={(value: Anzeige) => field.handleChange(value)}>
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-2">
                      <RadioGroupItem
                        className="data-[state=checked]:text-primary-blue-600 text-neutrals-300"
                        value="UMSATZ_PRODUKTIVITAET"
                        id="UMSATZ_PRODUKTIVITAET"
                      />
                      <Label
                        htmlFor="UMSATZ_PRODUKTIVITAET"
                        className="hover:cursor-pointer text-sm font-normal">
                        {t(
                          'domain.controlling.umsatzplanung.einstellungen.options.umsatzProduktivitaet.label',
                        )}
                      </Label>
                    </div>
                    {umsatzplanungAnzeige === 'UMSATZ_PRODUKTIVITAET' && (
                      <UmsatzProduktivitaetForm key="umsatzProduktivitaetForm" />
                    )}
                    <div className="flex items-center gap-2">
                      <RadioGroupItem
                        className="data-[state=checked]:text-primary-blue-600 text-neutrals-300"
                        value="ABSATZ_PRODUKTIVITAET"
                        id="ABSATZ_PRODUKTIVITAET"
                      />
                      <Label
                        htmlFor="ABSATZ_PRODUKTIVITAET"
                        className="hover:cursor-pointer text-sm font-normal">
                        {t(
                          'domain.controlling.umsatzplanung.einstellungen.options.absatzProduktivitaet.label',
                        )}
                      </Label>
                    </div>
                    {umsatzplanungAnzeige === 'ABSATZ_PRODUKTIVITAET' && (
                      <AbsatzProduktivitaetForm key="absatzProduktivitaetForm" />
                    )}
                    <div className="flex items-center gap-2">
                      <RadioGroupItem
                        className="data-[state=checked]:text-primary-blue-600 text-neutrals-300"
                        value="UMSATZ_ABSATZ_PRODUKTIVITAET"
                        id="UMSATZ_ABSATZ_PRODUKTIVITAET"
                      />
                      <Label
                        htmlFor="UMSATZ_ABSATZ_PRODUKTIVITAET"
                        className="hover:cursor-pointer text-sm font-normal">
                        {t(
                          'domain.controlling.umsatzplanung.einstellungen.options.umsatzUndAbsatzProduktivitaet.label',
                        )}
                      </Label>
                    </div>
                    {umsatzplanungAnzeige ===
                      'UMSATZ_ABSATZ_PRODUKTIVITAET' && (
                      <UmsatzAbsatzProduktivitaetForm key="umsatzAbsatzProduktivitaetForm" />
                    )}
                  </div>
                </RadioGroup>
              )}
            </form.AppField>
          )}
        </form.Subscribe>
      </div>
      <SheetFooter>
        <form.Subscribe
          selector={(state) => [state.canSubmit, state.isSubmitting]}>
          {([canSubmit, isSubmitting]) => (
            <Button
              disabled={!canSubmit || isSubmitting}
              onClick={() => form.handleSubmit()}>
              {!isSubmitting
                ? t('domain.controlling.umsatzplanung.ziele.fertig')
                : t(
                    'domain.controlling.umsatzplanung.einstellungen.update.isSubmitting',
                  )}
            </Button>
          )}
        </form.Subscribe>
      </SheetFooter>
    </SheetContent>
  );
}
